import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Копейка Геннадій',
  role: 'Голова комітету з альпінізму',
  email: 'g.kopeika@umcf.org.ua'
}, {
  name: 'Верба Олександр',
  role: 'Голова колегії суддів',
  email: 'olverba@gmail.com'
}, {
  name: 'Олівсон Олександр',
  role: 'Голова комісії зі скі-альпінізму та скайранінгу',
  email: 'olivson63@gmail.com'
}];
export function AlpinismCommittee() {
  return <FederationMembersPage title="Комітет альпінізму" subtitle="Керівний орган альпіністського напрямку ФАіСУ" members={members} data-id="element-386" />;
}